import DashboardMobileTabs from "./DashboardMobileComponents/DashboardMobileTabs"

const BizDevelopmentDashboardMobile = () => {
  return <DashboardMobileTabs />
}

export default BizDevelopmentDashboardMobile